// isDownloadOk accepts the two success statuses a content download can
// return. A plain object answers 200. Content stored as a multipart/tr-parts
// container is fetched with a Range header for the uploaded document
// (tech-designs/multipart-content.md), which S3 answers with 206.
export function isDownloadOk(response: Response | undefined): boolean {
  return !!response && (response.status === 200 || response.status === 206)
}
